import buttonStyle from "./button.module.css"


export default function Button(props) {

    const class_ = props['class'] || ''
    const style = props['style']
    const event = props['event']
    const text = props['text']

    return(
        <div
            className={`
                ${buttonStyle.button}
                ${class_}
            `}
            style={style}
            {...event}
        >{text}</div>
    )
}